import { METHODS } from '@system/acl/methods';
import type { UserInfo, matchesFn } from '@system/acl/types';

export function trainScheduleMatch(
  matches: Map<string, matchesFn>,
  userInfo: UserInfo,
): void {
  // /** =======================[ Перечень расписаний поездов ]============================ */
  // Создание
  matches.set(
    METHODS.train_schedules.createTrainSchedule,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Редактирование
  matches.set(
    METHODS.train_schedules.updateTrainSchedule,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Удаление
  matches.set(
    METHODS.train_schedules.deleteTrainSchedule,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );
}
